import { components } from "@certn/api/generated-schemas/applicant-portal";

export const CUSTOM_QUESTIONNAIRE_KEY = "custom_questionnaire_1";

export type CustomQuestionnaireAnswerType = Record<
  string,
  string | number | undefined | boolean | null
>;

export type CustomQuestionnaireFormType = {
  templateId: string;
  name: string;
  isCurrent: boolean;
  claims: components["schemas"]["CustomQuestionnaireTemplateInputClaim"][];
  answers: CustomQuestionnaireAnswerType;
  conditions?: components["schemas"]["CustomQuestionnaireTemplateInputClaimCondition"][];
};
